import React from "react";
import { usePutSegmentUniqueCountsByIdsQuery } from "@tiny/api";
import { AudienceSummaryProps } from "./AudienceSummary";

export function useAudienceSummary(props: AudienceSummaryProps) {
  const [includeGlobalSuppressed, setIncludeGlobalSuppressed] =
    React.useState(false);

  // If need to add local suppression control in future
  const [includeLocalSuppressed, setIncludeLocalSuppressed] =
    React.useState(false);

  const { segmentIds, noBorderRadius, onClose } = props;

  const { data, isLoading } = usePutSegmentUniqueCountsByIdsQuery(
    {
      segmentIds,
      includeGlobalSuppressed,
      includeLocalSuppressed,
    },
    {
      enabled: segmentIds.length > 0,
    }
  );

  const handleIncludeGlobalSuppressed = () => {
    setIncludeGlobalSuppressed(true);
  };

  const calculateSuprressionPercentage = (
    subscribedCount: number,
    globalSuppressed: number,
    localSuppressed: number
  ) => {
    const base = subscribedCount || 1;

    const globalPercent = (globalSuppressed / base) * 100;
    const localPercent = (localSuppressed / base) * 100;
    const subscribedPercent = 100 - (globalPercent + localPercent);
    const remainSubscription =
      subscribedCount - (globalSuppressed + localSuppressed);

    return {
      subscribedPercent,
      globalPercent,
      localPercent,
      remainSubscription,
    };
  };

  const subscribedCount = data?.subscribed ?? 0;
  const uniqueClicks = data?.uniqueClicks ?? 0;
  const uniqueOpens = data?.uniqueOpens ?? 0;
  const suppressedCount = data?.suppressed ?? 0;

  const clickedPercentage =
    subscribedCount > 0 ? (uniqueClicks / subscribedCount) * 100 : 0;
  const openedPercentage =
    subscribedCount > 0 ? (uniqueOpens / subscribedCount) * 100 : 0;

  return {
    subscribedCount,
    suppressedCount,
    clickedPercentage,
    openedPercentage,
    noBorderRadius,
    onClose,
    isps: data?.isps,
    isLoading,
    includeGlobalSuppressed,
    includeLocalSuppressed,
    handleIncludeGlobalSuppressed,
    calculateSuprressionPercentage,
  };
}
